import {
  getDetailsTabRoutes,
  getDetailsTabRouteObjects,
  getSelectableResult
} from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const catalogArtistListLDTRoutes = getDetailsTabRoutes(
  "catalog_artists",
  "label_artist_id"
);
export const labelsListLDTRoutes = getDetailsTabRoutes(
  "labels",
  "label_id"
);
export const projectsListLDTRoutes = getDetailsTabRoutes(
  "projects",
  "project_id"
);
export const releasesListLDTRoutes = getDetailsTabRoutes(
  "releases",
  "release_id"
);
export const productsListLDTRoutes = getDetailsTabRoutes(
  "products",
  "product_id"
);
export const tracksListLDTRoutes = getDetailsTabRoutes(
  "tracks",
  "track_id"
);
export const royaltyListLDTRoutes = getDetailsTabRoutes(
  "royalty",
  "royalty_id"
);
export const productGroupsLDTRoutes = getDetailsTabRoutes(
  "product_groups",
  "product_group_id"
);

export const productLDTRoutes = getDetailsTabRoutes(
  "product_groups",
  "product_group_id"
);

// export const statementsListLDTRoutes = getDetailsTabRoutes(
//   "statements",
//   "royalty_period_id"
// );

export const getArtistsDetailsSelectable = getSelectableResult(
  catalogArtistListLDTRoutes
);
export const getLabelsDetailsSelectable = getSelectableResult(
  labelsListLDTRoutes
);
export const getProjectsDetailsSelectable = getSelectableResult(
  projectsListLDTRoutes
);
export const getReleasesDetailsSelectable = getSelectableResult(
  releasesListLDTRoutes
);
export const getProductsDetailsSelectable = getSelectableResult(
  productsListLDTRoutes
);
export const getTracksDetailsSelectable = getSelectableResult(
  tracksListLDTRoutes
);
export const getRoyaltyDetailsSelectable = getSelectableResult(
  royaltyListLDTRoutes
);
export const getProductGroupsDetailsSelectable = getSelectableResult(
  productGroupsLDTRoutes
);
// export const getStatementDetailsSelectable = getSelectableResult(
//   statementsListLDTRoutes
// );
export const moduleRoutes = [
  catalogArtistListLDTRoutes,
  labelsListLDTRoutes,
  projectsListLDTRoutes,
  releasesListLDTRoutes,
  productsListLDTRoutes,
  tracksListLDTRoutes,
  royaltyListLDTRoutes,
  productGroupsLDTRoutes,
 // statementsListLDTRoutes
];

const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
  return detailsRoutes
    .map(r => childOfOrEqual(r))
    .some(f => f(route.name));
};
